import { FC } from 'react';
import type { ApplyStatus } from 'state/tradeAllocationForm';

import { ErrorStatus } from './ErrorStatus';
import { InitializedStatus } from './InitializedStatus';
import { PendingStatus } from './PendingStatus';
import type { StatusProps } from './Status.connect';
import { connectStatus } from './Status.connect';
import { SuccessStatus } from './SuccessStatus';

function componentForStatus(applyStatus?: ApplyStatus) {
  switch (applyStatus) {
    case undefined:
    case 'Initialized':
      return InitializedStatus;
    case 'Pending':
      return PendingStatus;
    case 'Done':
      return SuccessStatus;
    case 'Error':
      return ErrorStatus;
    default:
      throw new Error(`status ${applyStatus} is not supported `);
  }
}

const StatusComponent: FC<StatusProps> = ({ applyStatus, tabId }) => {
  const Comp = componentForStatus(applyStatus);
  return (
    <div id="side-panel-status" data-e2e="side-panel-status">
      {Comp !== null && <Comp tabId={tabId} />}
    </div>
  );
};

StatusComponent.displayName = 'Status';

export const Status = connectStatus(StatusComponent);
